import React from "react";
import DashShell from "@/components/DashShell";
import {
  LayoutDashboard, Inbox, GitBranch, Briefcase, Building2, HeartHandshake, CheckSquare,
  DollarSign, Calculator, GraduationCap, FileText, Bot, BookOpen, Rocket, User,
} from "lucide-react";

const ITEMS = [
  { to: "/app", label: "My Dashboard", icon: LayoutDashboard, end: true },
  { to: "/app/leads", label: "My Leads", icon: Inbox },
  { to: "/app/pipeline", label: "My Pipeline", icon: GitBranch },
  { to: "/app/opportunities", label: "Available Opportunities", icon: Briefcase },
  { to: "/app/providers", label: "My Providers", icon: Building2 },
  { to: "/app/referral-sources", label: "My Referral Sources", icon: HeartHandshake },
  { to: "/app/tasks", label: "My Tasks", icon: CheckSquare },
  { to: "/app/commissions", label: "My Commissions", icon: DollarSign },
  { to: "/app/calculator", label: "Commission Calculator", icon: Calculator },
  { to: "/app/training", label: "Training", icon: GraduationCap },
  { to: "/app/scripts", label: "Scripts", icon: FileText },
  { to: "/app/ai", label: "AI Assistant", icon: Bot },
  { to: "/app/resources", label: "Resources", icon: BookOpen },
  { to: "/app/build", label: "Build My Business", icon: Rocket },
  { to: "/app/account", label: "Account", icon: User },
];

export default function AgentApp() {
  return <DashShell items={ITEMS} title="Placement Professional" />;
}
